import './secondaryHeader.css';

import React, { cloneElement, useState } from 'react';
import { menuItemActionToMenuItem } from '@bentley/pw-components';
import { href, productionEnvironment } from '@bentley/pw-config';
import {
  SvgDeveloper,
  SvgLightbulb,
  SvgMoreVertical
} from '@itwin/itwinui-icons-react';
import { DropdownMenu, IconButton, Text, Tooltip } from '@itwin/itwinui-react';
import { useConfigContext } from '../../context';
import { t } from '../../services/translation';
import { WelcomeModal } from '../welcome';

export function SecondaryHeader(): JSX.Element {
  const { productIcon, productName, config } = useConfigContext();

  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  const menuActions = [
    {
      title:
        config.DataAccessLevel == 'Datasource'
          ? t('ProductName.AboutProjectWiseWebView')
          : t('ProductName.AboutProjectWiseWeb'),
      icon: productIcon,
      onClick: () => setShowWelcomeModal(true)
    },
    {
      title: t('SecondaryHeader.UserFeedback'),
      icon: <SvgLightbulb />,
      onClick: () => {
        window.open(href.aha);
      },
      ['data-testid']: 'user-feedback'
    }
  ];

  return (
    <div className="secondary-header">
      {cloneElement(productIcon, { className: 'product-icon' })}
      {productName}
      <div className="secondary-header-right-side">
        <span data-testid="e2eTestName" style={{ marginRight: '20px' }} />
        <DisplayAppVersion />
        <DisplayCoverageIndicator />
        <DropdownMenu
          menuItems={(close: () => void) =>
            menuActions.map((action) => menuItemActionToMenuItem(action, close))
          }
        >
          <IconButton
            styleType="borderless"
            className="settings-dropdown"
            data-testid="settings-dropdown"
            label={t('SecondaryHeader.About')}
          >
            <SvgMoreVertical />
          </IconButton>
        </DropdownMenu>
      </div>
      <WelcomeModal
        isOpen={showWelcomeModal}
        onClose={() => setShowWelcomeModal(false)}
      />
    </div>
  );
}

function DisplayAppVersion(): JSX.Element | null {
  const { config } = useConfigContext();

  const version: string = config.AppVersion;
  const branchNameDisplay = config.branchName?.split('/').pop();
  const appVersion = `v${version} branch ${branchNameDisplay}`;

  if (productionEnvironment() !== 'prod') {
    return (
      <Text variant="small" className="app-version">
        {appVersion}
      </Text>
    );
  }

  return null;
}

function DisplayCoverageIndicator(): JSX.Element | null {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
  if (!(window as any).__coverage__) {
    return null;
  }

  return (
    <Tooltip content="Code instrumented for coverage" placement="bottom-end">
      <span className="coverage-indicator">
        <SvgDeveloper data-testid="coverage-indicator" />
      </span>
    </Tooltip>
  );
}
